var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"data-table"},[_c('list',{attrs:{"infiniteId":_vm.infiniteId,"headers":_vm.headers,"list":_vm.partnersList,"loading":false},on:{"load":_vm.load},scopedSlots:_vm._u([{key:"default",fn:function(slotProps){return [_c('partners-table-item',{attrs:{"data-item":slotProps.item}})]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }